import { useLocation } from '@reach/router'

interface ReturnValue {
  /** 現在いるパス */
  readonly currentPath: string
}

/**
 * @file
 * 現在いるパスを取得するカスタムフック
 *
 * @returns @see {@link ReturnValue} を参照
 * @example
 * const { currentPath } = useGetCurrentPath()
 * console.log(currentPath) // /news/
 */
export const useGetCurrentPath = (): ReturnValue => {
  const location = useLocation()

  return {
    currentPath: location.pathname,
  }
}
